import React from 'react';

const LoadingSpinner = ({ size = 40, color = '#1e40af' }) => {
    return (
        <div
            style={{
                width: `${size}px`,
                height: `${size}px`,
                border: `3px solid #e5e7eb`,
                borderTop: `3px solid ${color}`,
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto'
            }}
        >
            <style>
                {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
            </style>
        </div>
    );
};

export default LoadingSpinner;